// extracted by mini-css-extract-plugin
module.exports = {"calendar":"YearInput_calendar__375NT","date":"YearInput_date__3IK_5"};